module.exports = __webpack_public_path__ + "static/media/west-elm-large_2x.37fc3a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/west-elm-large_2x.png
// module id = 716
// module chunks = 27